import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import Image from "../../../lib/Image";
import { splitStr } from "../../../utils/commonFunc";

SwiperCore.use([Pagination]);

export default (props) => {
  return (
    <Swiper
      style={{
        paddingBottom:
          props.type == 1 &&
          props.banners.length > 0 &&
          props.banners.length < 2
            ? "20px"
            : (props.type == 1 && props.banners.length === 0) ||
                (props.type == 3 && props.banners.length < 2)
              ? 0
              : "36px",
      }}
      // autoplay={true}
      loop={true}
      pagination={{ clickable: true }}
    >
      {props.banners.map((banner) => (
        <SwiperSlide key={banner.game_id}>
          <Link
            to={"/game?id=" + banner.game_id}
            className="banner"
            onClick={() => {
              document.body.style.overflow = "unset";
            }}
          >
            <div className="img">
              <Image src={banner.img} />
            </div>

            <div
              className="game-list-global-type"
              style={{ padding: "14px 0 15px 14px", margin: 0 }}
            >
              <div className="game-list-global-type-left">
                <div
                  className="icon"
                  style={{
                    width: "1.08rem",
                    height: "1.08rem",
                    marginRight: "8px",
                  }}
                >
                  <Image src={banner.icon} />
                </div>

                <div className="data">
                  <div className="name" style={{ marginBottom: "8px" }}>
                    <div
                      className="name-main"
                      style={{ flex: "none", fontSize: "0.28rem" }}
                    >
                      {banner.game_name_main || banner.game_name}
                    </div>
                  </div>

                  <div
                    className="desc"
                    style={{ marginBottom: 0, fontSize: "0.2rem" }}
                  >
                    {splitStr(banner.version)}

                    {banner.game_name_branch && (
                      <>
                        <div className="circle"></div>
                        {banner.game_name_branch}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {banner.discount < 1 ? (
                <div
                  className="is-free-version"
                  style={{ marginRight: "23px" }}
                >
                  {parseFloat((banner.discount * 10).toFixed(2))}折
                </div>
              ) : null}
            </div>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
